import styled from 'styled-components';

export const Form = styled.form`
  width: ${({ theme }) => theme.spacing[112]};
  max-width: 100%;
`;
